import { useContext, useEffect, useState } from "react";
import ProfileImg from "../../assets/img/profileImg.svg";
import EmployeImg from "../../assets/img/experianCheck.svg";
import notIcon from "../../assets/img/noticIcon.svg";
import Flatmates from "../../assets/img/Flatmates.svg";
import VectorIcon from "../../assets/img/VectorIcon1.svg";
import bagImg from "../../assets/img/employeSVG.svg";
import Guarantors from "../../assets/img/Guarantors.svg";
import WhiteBackgroundGuarantor from "../../assets/img/WhiteBackgroundGuarantor.svg";
import moreInfoimg from "../../assets/img/moreInfoimg.svg";
import ExchangeIcon from "../../assets/img/exchange-icon.svg";
import Cancelimg from "../../assets/img/cancel-01.svg";
import MissingIcon from "../../assets/img/zondicons.svg";
import crossIcon from "../../assets/img/cross-new.svg";
import useTranslator from "../../hooks/useTranslator";
import {
  amlKycChecks,
  getIdentityDetails,
  haveValue,
  isDefaulter,
  ONFIDO_TOOLTIP_PRIORITY,
} from "../../helper/common";
import constants from "../../Utils/constants";
import UserBack from "../../assets/img/arrow-left-02-round.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import FlatmateModel from "./FlatmateModal";
import FlatmateOrGuarantorAddForm from "./FlatmateOrGuarantorAddForm";
import axiosInstance from "../../services/authWrapper";
import AuthContext from "../../context/auth/AuthContext";
import FullidAuthentication from "../Tenant/FullidAuthentication";
import { useMediaQuery } from "react-responsive";
import Summary from "../Summary";
import FreeTextModal from "../Tenant/FreeTextModal";
import { Tooltip as ReactTooltip } from "react-tooltip";
import KycAmlCheckReportModal from "./KycAmlCheckReportModal";
import { WORKSPACE_ROLES_CAPABILITIES } from "../../Utils/workspaceRoleCapabilities";

const TenantDetailsHeader = (props) => {
  const { _t } = useTranslator();
  const isMobile = useMediaQuery({ maxWidth: 667 });
  const queryParameters = new URLSearchParams(window.location.search);
  const { workspaceId } = useParams();
  const guarantor_id = queryParameters.get("guarantor");
  const llShowOnly = localStorage.getItem("usertype") == "landlord";
  let [isFirstTime, setIsFirstTime] = useState(
    queryParameters.get("welcome") ?? false,
  );
  const [showModal, setShowModal] = useState(false);
  const [showKycPopup, setShowKycPopup] = useState(false);
  const [showFreeTextPopup, setShowFreeTextPopup] = useState(false);
  const [isOpenSummary, setIsOpenSummary] = useState(false);
  const [showAmlKycChecks, setShowAmlKycChecks] = useState(false);

  const { loadUser, user: originalUser } = useContext(AuthContext);

  const {
    user = {},
    forensicAnalysis = null,
    userIncome = {},
    setShowDefaulterCheck,
    setInsurableModal,
    fullinfo,
    setUpdateSourceObj,
    handleUpdateSource,
    showReportIcons = true,
    setOpenGuarantorModel,
    isGuarantor,
    isFromReport,
    setShowChatBot,
    SetIsSentEmailDrawer,
    updateTenantData,
    loadFullInfo,
  } = props;

  const experianData =
    user?.tenant_extra_field_id?.experianJson?.["s:Envelope"]?.["s:Body"]
      ?.GenerarInformeResponse?.GenerarInformeResult?.InformeDelphi4A3;

  const [kycDetails, setKycDetails] = useState(null);
  useEffect(() => {
    setKycDetails(getIdentityDetails(user, user?.onfido_user_kyc));
  }, [user]);

  const getEmploymentStatus = () => {
    if (user?.employment_status == constants.employed) {
      return _t("employed");
    }
    if (user?.employment_status == constants.self_employed) {
      return _t("selfEmployed");
    }
    if (user?.employment_status == constants.student) {
      return _t("student");
    }
    if (user?.employment_status == constants.unemployed) {
      return _t("unemployed");
    }
    if (user?.employment_status == constants.retired) {
      return _t("retired");
    }
    if (user?.employment_status == constants.public_servant) {
      return _t("publicServant");
    }
  };
  const navigate = useNavigate();
  const location = useLocation();
  const [flatmateAddFormModal, setFlatmateAddFormModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("i18nextLng").toLowerCase() || "en-us",
  );

  useEffect(() => {
    setCurrentLang(localStorage.getItem("i18nextLng").toLowerCase() || "en-us");
  }, [localStorage.getItem("i18nextLng")]);

  const handleChangeSource = () => {
    handleUpdateSource();
    setUpdateSourceObj([
      {
        _id: userIncome?.all_sources?._id,
        all_sources: userIncome?.all_sources,
        current_selected: userIncome?.source,
        type: "tenant",
      },
    ]);
  };

  const updateUserSharerData = async (data) => {
    try {
      if (!haveValue(data?.is_edit)) {
        data.is_edit = true;
      }
      await axiosInstance.patch(
        `${process.env.REACT_APP_SERVER_URL}/users/profile/${user?._id}`,
        data,
        {
          headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
        },
      );
      loadUser("tenant");
    } catch (error) {
      console.log("Error updating user");
    }
  };

  const getConsiderResult = (breakdown, path) => {
    const [section, field] = path.split(".");

    const sectionData = breakdown?.[section];
    if (!sectionData) return false;

    // Check nested breakdown field result
    const fieldResult = sectionData?.breakdown?.[field]?.result;
    if (fieldResult === "consider") return true;

    // Also catch properties-level "consider" (e.g. original_document_present.properties.*)
    const properties = sectionData?.breakdown?.[field]?.properties;
    if (properties) {
      return Object.values(properties).some((v) => v === "consider");
    }

    return false;
  };

  const getReviewReason = () => {
    const breakdown =
      user?.onfido_user_kyc?.onfido_workflow_res?.resource?.output
        ?.document_report?.breakdown;

    if (!breakdown) return null;

    for (const { path, message } of ONFIDO_TOOLTIP_PRIORITY) {
      if (getConsiderResult(breakdown, path)) {
        return _t(message);
      }
    }

    const hasAnyConsider = Object.values(breakdown).some(
      (section) =>
        section?.result === "consider" ||
        Object.values(section?.breakdown ?? {}).some(
          (field) => field?.result === "consider",
        ),
    );

    return hasAnyConsider ? _t("onfidoFallbackMessage") : null;
  };

  const flaggedGuarantors =
    !llShowOnly &&
    Array.isArray(user?.tenant_extra_field_id?.selected_onboarding_users)
      ? user.tenant_extra_field_id.selected_onboarding_users?.filter(
          (item) => item?.type == "guarantor",
        )?.length
      : 0;

  const handleNavigateReport = () => {
    const sharedId =
      queryParameters.get("agencylink") ||
      queryParameters.get("sharedprofileid");
    let queryParam = haveValue(queryParameters.get("agencylink"))
      ? `agencylink=${sharedId}`
      : `sharedprofileid=${sharedId}`;
    if (haveValue(guarantor_id)) {
      queryParam += `&guarantor_id=${guarantor_id}`;
    }

    const redirectUrl = window.location.pathname + window.location.search;
    queryParam += `&redirectUrl=${encodeURIComponent(redirectUrl)}`;

    window.open(
      `${window.location.protocol}//${process.env.REACT_APP_URL_NAME}/${
        haveValue(workspaceId) ? workspaceId + "/" : ""
      }generatedReport/${sharedId}?${queryParam}`,
      "_blank",
    );
  };

  const IncomeTooltip = () => (
    <>
      <img
        data-tooltip-id="tenant-details-header-tooltip"
        src={moreInfoimg}
        alt="Vector Icon"
        className="vactorImg vactorImg1"
      />
      <ReactTooltip
        id="tenant-details-header-tooltip"
        place="left"
        noArrow
        className="react-tooltip-styling"
        render={() => (
          <p>
            {haveValue(userIncome?.method)
              ? _t(userIncome?.method)
              : _t("noIncomeSelected")}
          </p>
        )}
      />
    </>
  );

  const isInsurable = haveValue(originalUser?.agency_id)
    ? originalUser?.agency_id?.insurance_service_status
    : originalUser?.insurance_service_status;

  useEffect(() => {
    if (isOpenSummary) {
      document.body.classList.add("profile-open");
    } else {
      document.body.classList.remove("profile-open");
    }

    return () => document.body.classList.remove("profile-open");
  }, [isOpenSummary]);

  const { pathname } = useLocation();

  const hideContainer =
    pathname.includes("generatedReport") ||
    pathname.includes("report-overview");

  const handleGoBack = () => {
    const currentFullPath = location.pathname + location.search + location.hash;
    const fallbackPath = `/${workspaceId}/profile-request`;
    const maxAttempts = 5; // Prevent infinite loops
    let attempts = 0;

    const tryNavigateBack = () => {
      const currentIdx = window.history.state?.idx || 0;

      if (currentIdx === 0 || attempts >= maxAttempts) {
        // No more history or too many attempts
        navigate(fallbackPath, { replace: true });
        return;
      }

      navigate(-1);
      attempts++;

      setTimeout(() => {
        const newFullPath =
          window.location.pathname +
          window.location.search +
          window.location.hash;

        if (newFullPath === currentFullPath) {
          // Still on same URL, try again
          tryNavigateBack();
        }
        // If URL changed, we're done (navigation succeeded)
      }, 50);
    };

    if (window.history.state?.idx > 0) {
      tryNavigateBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      <div
        className={`${!hideContainer && "profileinfo"} ${
          !llShowOnly ? "profileTenant" : ""
        } ${isFromReport ? "profileinfoReport" : ""}`}
      >
        <div className="row">
          <div className="col">
            <div className="mobileNavbar hideOnDesktop">
              {llShowOnly && (
                <p
                  className="Profileheading_change1 hideOnDesktop"
                  onClick={() => navigate(-1)}
                >
                  <img src={UserBack} alt="Vector Icon" className="vactorImg" />
                </p>
              )}
              <div className="userfixed_css d-flex align-items-center justify-content-center">
                <div>
                  <p className="Profileheading_change">
                    {haveValue(forensicAnalysis?.Name?.dataInJSON?.name) ? (
                      (() => {
                        const name =
                          forensicAnalysis.Name.dataInJSON.name.trim();
                        const parts = name.split(/\s+/);
                        let prefix = "";

                        if (parts.length >= 2) {
                          prefix =
                            parts[0].charAt(0).toUpperCase() +
                            parts[1].charAt(0).toUpperCase();
                        } else {
                          prefix = parts[0].charAt(0).toUpperCase();
                        }

                        return prefix;
                      })()
                    ) : (
                      <>
                        {user?.fname && user.fname.charAt(0).toUpperCase()}
                        {user?.lname && user.lname.charAt(0).toUpperCase()}
                      </>
                    )}
                  </p>
                </div>
              </div>
              <div className="hideOnDesktop incomeMobile">
                <div className="incomeDiv">
                  <div className="d-flex gap-2">
                    <div className="w-100">
                      <div className="d-flex align-items-center gap-2">
                        <p className="Profileheading_change mb-2">
                          {_t(
                            "selectedAnnualIncome",
                            "On new Skor Lite tenantDetails page header",
                          )}
                        </p>
                        <img
                          data-tooltip-id="userincome-method-tooltip"
                          src={moreInfoimg}
                          alt="Vector Icon"
                          className="vactorImg vactorImg1"
                        />
                        <ReactTooltip
                          id="userincome-method-tooltip"
                          place="bottom"
                          noArrow
                          className="react-tooltip-styling"
                          render={() => <p> {userIncome?.method} </p>}
                        />
                      </div>
                      <div className="d-flex align-items-center justify-content-between gap-4">
                        <div className="d-flex align-items-center">
                          <p className="Profileheading_change3">
                            €{userIncome?.amount}
                          </p>
                          {showReportIcons &&
                            llShowOnly &&
                            haveValue(userIncome?.all_sources) && (
                              <div className="re-do-icon-wrapper header-icon-wrapper">
                                <img
                                  src={ExchangeIcon}
                                  alt=""
                                  onClick={handleChangeSource}
                                  style={{ cursor: "pointer" }}
                                />
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="documentNumberWrapper">
                <div className="d-flex gap-2">
                  <img src={bagImg} alt="Vector Icon" className="vactorImg" />
                  <div>
                    <p className="Profileheading_change mb-2">
                      {_t("employmentStatus")}
                    </p>
                    <p className="Profileheading_change2">
                      {getEmploymentStatus()}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`profileheading ${
                !llShowOnly ? "profileHeadingMobile" : ""
              }`}
            >
              <div className="row">
                {showReportIcons && (llShowOnly || haveValue(guarantor_id)) && (
                  <div
                    className="col-1 hideOnMobile cursor-pointer"
                    onClick={handleGoBack}
                  >
                    <div className="userfixed_css userback_css d-flex align-items-center justify-content-center">
                      <div>
                        <p className="Profileheading_change1">
                          <img
                            src={UserBack}
                            alt="Vector Icon"
                            className="vactorImg"
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                <div
                  className={`col-1 hideOnMobile ${
                    showReportIcons && (llShowOnly || haveValue(guarantor_id))
                      ? "ps-0"
                      : ""
                  }`}
                >
                  <div className="userfixed_css d-flex align-items-center justify-content-center">
                    <div>
                      <p className="Profileheading_change">
                        {haveValue(forensicAnalysis?.Name?.dataInJSON?.name) ? (
                          (() => {
                            const name =
                              forensicAnalysis.Name.dataInJSON.name.trim();
                            const parts = name.split(/\s+/);
                            let prefix = "";

                            if (parts.length >= 2) {
                              prefix =
                                parts[0].charAt(0).toUpperCase() +
                                parts[1].charAt(0).toUpperCase();
                            } else {
                              prefix = parts[0].charAt(0).toUpperCase();
                            }

                            return prefix;
                          })()
                        ) : (
                          <>
                            {user?.fname && user.fname.charAt(0).toUpperCase()}
                            {user?.lname && user.lname.charAt(0).toUpperCase()}
                          </>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                {!llShowOnly && (
                  <div
                    className={`col documentNumberWrapper kycNumberWrapper ${
                      llShowOnly ? "guarantorCountWrapper" : ""
                    }`}
                  >
                    <div className="d-flex gap-2">
                      <img
                        src={ProfileImg}
                        alt="Vector Icon"
                        className="vactorImg"
                      />
                      <div className="documentNumberContainer">
                        <p className="Profileheading_change mb-2">
                          {kycDetails?.type === "dni"
                            ? _t(
                                "dniNieDetails",
                                "On new Skor Lite tenantDetails page header",
                              )
                            : _t("passport")}
                        </p>
                        <div className="d-flex align-items-center custom-gap-2 numberWrapper">
                          <p className="Profileheading_change2">
                            {kycDetails?.value}
                            {haveValue(
                              user?.onfido_user_kyc?.onfido_workflow_res,
                            ) &&
                              (() => {
                                const status =
                                  user?.onfido_user_kyc?.onfido_workflow_res
                                    ?.resource?.status;

                                const isDeclined = status === "declined";
                                const isReview = status === "review";

                                if (
                                  !haveValue(status) ||
                                  (!isDeclined && !isReview)
                                )
                                  return null;

                                const icon = isDeclined
                                  ? crossIcon
                                  : MissingIcon;
                                const extraClass = isReview
                                  ? "exclamationIcon"
                                  : "";

                                return (
                                  <div className="exclamationIconWrapper">
                                    <img
                                      src={icon}
                                      className={`missingIcon ${extraClass}`}
                                    />
                                    <div className="guarantor-hover exclamationHover">
                                      <div className="content-hover-div">
                                        <div className="d-flex align-items-center custom-gap-2">
                                          <p className="text-break contentText">
                                            {getReviewReason()}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })()}
                          </p>
                          {!llShowOnly && (
                            <div
                              className="cursor-pointer editButton"
                              onClick={() => setShowKycPopup(true)}
                            >
                              <img src={"/images/redoIcon.svg"} />
                              <p>{_t("redo")}</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="col documentNumberWrapper hideOnMobile">
                  <div className="d-flex gap-2">
                    <img src={bagImg} alt="Vector Icon" className="vactorImg" />
                    <div>
                      <p className="Profileheading_change mb-2">
                        {_t("employmentStatus")}
                      </p>
                      <p className="Profileheading_change2">
                        {getEmploymentStatus()}
                      </p>
                    </div>
                  </div>
                </div>
                {llShowOnly &&
                  haveValue(user?.onfido_user_kyc?.onfido_workflow_res) && (
                    <div
                      style={{ minWidth: "fit-content" }}
                      className="col documentNumberWrapper kycNumberWrapper guarantorCountWrapper"
                    >
                      <div className="d-flex gap-2">
                        <img
                          src={ProfileImg}
                          alt="Vector Icon"
                          className="vactorImg"
                        />
                        <div
                          className="cursor-pointer"
                          onClick={(e) => setShowAmlKycChecks(true)}
                        >
                          <p className="Profileheading_change mb-2">
                            {_t("kycAndAmlChecks")}
                          </p>
                          <div className="d-flex align-items-center gap-1">
                            <img
                              src={
                                amlKycChecks(user)
                                  ? "/images/trusted.svg"
                                  : notIcon
                              }
                              alt=""
                              className="notIconHeader"
                            />
                            <p className="Profileheading_change2">
                              {_t(
                                amlKycChecks(user)
                                  ? "approvedKycAml"
                                  : "notApprovedKycAMl",
                              )}
                            </p>
                            {showReportIcons && (
                              <img
                                className="Imagerutate ImageSizeSet ms-1"
                                src={VectorIcon}
                                alt="Vector Icon"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                {llShowOnly && (
                  <div className="col documentNumberWrapper kycNumberWrapper guarantorCountWrapper">
                    <div className="d-flex gap-2">
                      <img
                        src={EmployeImg}
                        alt="Vector Icon"
                        className="vactorImg"
                      />
                      <div
                        className="cursor-pointer"
                        onClick={(e) => setShowDefaulterCheck(true)}
                      >
                        <p className="Profileheading_change mb-2">
                          {_t("experianCheck")}
                        </p>
                        <div className="d-flex align-items-center gap-1">
                          <img
                            src={
                              isDefaulter(experianData)
                                ? notIcon
                                : "/images/trusted.svg"
                            }
                            alt=""
                            className="notIconHeader"
                          />
                          <p className="Profileheading_change2">
                            {_t(isDefaulter(experianData) ? "no" : "yes")}
                          </p>
                          {showReportIcons && (
                            <img
                              className="Imagerutate ImageSizeSet ms-1"
                              src={VectorIcon}
                              alt="Vector Icon"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {llShowOnly && isInsurable && (
                  <div className="col documentNumberWrapper kycNumberWrapper guarantorCountWrapper">
                    <div
                      className="d-flex gap-2 cursor-pointer"
                      onClick={() => setInsurableModal(true)}
                    >
                      <img
                        src="/images/shield.svg"
                        alt="Vector Icon"
                        className="vactorImg"
                      />
                      <div className="cursor-pointer">
                        <p className="Profileheading_change mb-2">
                          {_t("insurable")}
                        </p>
                        <div className="d-flex align-items-center gap-1">
                          <img
                            src={
                              isDefaulter(experianData)
                                ? notIcon
                                : "/images/trusted.svg"
                            }
                            alt=""
                            className="notIconHeader"
                          />
                          <p className="Profileheading_change2">
                            {_t(!isDefaulter(experianData) ? "yes" : "no")}
                          </p>
                          <img
                            className="Imagerutate ImageSizeSet ms-1"
                            src={VectorIcon}
                            alt="Vector Icon"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="col documentNumberWrapper kycNumberWrapper guarantorCountWrapper">
                  <div
                    className="d-flex gap-2 cursor-pointer"
                    onClick={() => {
                      if (isMobile && !llShowOnly) {
                        if (
                          +(
                            user?.gurantor_added_id?.length +
                              flaggedGuarantors ?? 0
                          ) === 0
                        ) {
                          navigate("/guarantor/onboarding");
                        } else {
                          setOpenGuarantorModel(true);
                        }
                      } else if (
                        showReportIcons &&
                        ((user?.gurantor_for?.length ?? 0) > 0 ||
                          (user?.gurantor_id?.length ?? 0) > 0 ||
                          +(
                            user?.gurantor_added_id?.length +
                              flaggedGuarantors ?? 0
                          ) > 0)
                      ) {
                        setOpenGuarantorModel(true);
                      }
                    }}
                  >
                    <img
                      src={Guarantors}
                      alt="Vector Icon"
                      className="vactorImg"
                    />
                    <div className="wrapper">
                      <p className="Profileheading_change mb-2">
                        {user?.gurantor_for?.length > 0 || isGuarantor
                          ? _t("guarantorFor")
                          : _t("guarantors")}
                      </p>
                      <div className="d-flex align-items-center custom-gap-2">
                        <p className="Profileheading_change2">
                          {user?.gurantor_for?.length > 0 || isGuarantor
                            ? (user?.gurantor_for?.length ?? 0)
                            : (((llShowOnly
                                ? user?.gurantor_added_id?.filter((item) =>
                                    [
                                      "processing",
                                      "present",
                                      "accepted",
                                    ].includes(item.status),
                                  )?.length
                                : user?.gurantor_added_id?.length) ?? 0) +
                                flaggedGuarantors ?? 0)}
                        </p>
                        {showReportIcons &&
                          ((user?.gurantor_for?.length ?? 0) > 0 ||
                            (user?.gurantor_id?.length ?? 0) > 0 ||
                            +(
                              user?.gurantor_added_id?.length +
                                flaggedGuarantors ?? 0
                            ) > 0) && (
                            <img
                              className="Imagerutate ImageSizeSet"
                              src={VectorIcon}
                              alt="Vector Icon"
                            />
                          )}
                        {!isGuarantor &&
                          !llShowOnly &&
                          !((user?.gurantor_for?.length ?? 0) > 0) && (
                            <div
                              className="cursor-pointer editButton"
                              onClick={
                                +(
                                  user?.gurantor_added_id?.length +
                                    flaggedGuarantors ?? 0
                                ) === 0
                                  ? () => navigate("/guarantor/onboarding")
                                  : () => setOpenGuarantorModel(true)
                              }
                            >
                              <img
                                src={
                                  +(
                                    user?.gurantor_added_id?.length +
                                      flaggedGuarantors ?? 0
                                  ) === 0
                                    ? "/images/addGreen.svg"
                                    : "/images/editGreen.svg"
                                }
                              />
                              <p>
                                {+(
                                  user?.gurantor_added_id?.length +
                                    flaggedGuarantors ?? 0
                                ) === 0
                                  ? `${_t("add")}`
                                  : `${_t("edit")}`}
                              </p>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                  {isFirstTime && (
                    <div className="guarantor-hover ">
                      <div className="content-hover-div">
                        <div className="d-flex align-items-center custom-gap-2">
                          <img
                            src={WhiteBackgroundGuarantor}
                            alt="Vector Icon"
                            className="vactorImg"
                            style={{ height: "2.361vw", width: "2.361vw" }}
                          />
                          <p className="text-break contentText">
                            {_t(
                              "addAGuarantorToMakeYourEffortRateMaxRentMoreStrong",
                            )}
                          </p>
                        </div>
                        <img
                          src={Cancelimg}
                          alt=""
                          style={{
                            position: "absolute",
                            top: "1.042vw",
                            right: "0.8vw",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            setIsFirstTime(false);
                            const url = new URL(window.location.href);
                            url.search = ""; // ⛔️ Clear all query parameters
                            window.history.pushState({}, "", url.toString());
                          }}
                        />
                        <div className="d-flex justify-content-end">
                          <button
                            type="button"
                            className="btnNext get-back-btn cursor-pointer"
                            onClick={(e) => navigate("/guarantor/onboarding")}
                          >
                            {_t("addGuarantor")}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {!isGuarantor && !(user?.gurantor_for?.length ?? 0) > 0 && (
                  <div className="col documentNumberWrapper kycNumberWrapper guarantorCountWrapper">
                    <div
                      className="d-flex gap-2 cursor-pointer"
                      onClick={() => {
                        if (isMobile && !llShowOnly) {
                          if ((user?.sharers?.length ?? 0) === 0) {
                            setFlatmateAddFormModal(true);
                          } else {
                            setShowModal(true);
                          }
                        } else if (
                          showReportIcons &&
                          ((user?.sharers?.length ?? 0) > 0 ||
                            (user?.tenant_extra_field_id
                              ?.selected_onboarding_users?.length ?? 0) > 0)
                        ) {
                          setShowModal(true);
                        }
                      }}
                    >
                      <img
                        src={Flatmates}
                        alt="Vector Icon"
                        className="vactorImg"
                      />
                      <div className="wrapper">
                        <p className="Profileheading_change mb-2">
                          {_t("flatmates")}
                        </p>
                        <div className="d-flex align-items-center custom-gap-2">
                          <p className="Profileheading_change2">
                            {user?.sharers?.length ?? 0}
                          </p>
                          {showReportIcons &&
                            ((user?.sharers?.length ?? 0) > 0 ||
                              (user?.tenant_extra_field_id
                                ?.selected_onboarding_users?.length ?? 0) >
                                0) && (
                              <img
                                className="Imagerutate ImageSizeSet"
                                src={VectorIcon}
                                alt="Vector Icon"
                              />
                            )}
                          {!llShowOnly && (
                            <div
                              className="cursor-pointer editButton"
                              onClick={
                                (user?.sharers?.length ?? 0) === 0
                                  ? () => setFlatmateAddFormModal(true)
                                  : () => setShowModal(true)
                              }
                            >
                              <img
                                src={
                                  (user?.sharers?.length ?? 0) === 0
                                    ? "/images/addGreen.svg"
                                    : "/images/editGreen.svg"
                                }
                              />
                              <p>
                                {(user?.sharers?.length ?? 0) === 0
                                  ? `${_t("add")}`
                                  : `${_t("edit")}`}
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {llShowOnly && isInsurable && (
                  <div
                    style={{ maxWidth: "fit-content", paddingLeft: "0" }}
                    className="col-1 d-flex align-items-end justify-content-end hideOnMobile"
                  >
                    {" "}
                    <IncomeTooltip />
                  </div>
                )}
              </div>
            </div>
          </div>
          <Summary
            user={user}
            showReportIcons={showReportIcons}
            setShowChatBot={setShowChatBot}
            llShowOnly={llShowOnly}
            isShowOnMobile={true}
            isOpen={isOpenSummary}
            setIsOpen={setIsOpenSummary}
          />
          <div
            className={`${
              llShowOnly ? "col-md-2 aboutMeCardWrapper" : "col-md-2"
            }`}
          >
            <div
              className="col incomeDiv aboutMeCard"
              onClick={() => llShowOnly && setIsOpenSummary(true)}
            >
              <div
                className={`d-flex gap-2 ${
                  llShowOnly ? "h-100 mainWrapperButtonHeading" : ""
                }`}
              >
                <div className="w-100 wrapperButtonHeading">
                  <div className="d-flex align-items-center custom-gap-2">
                    <img
                      src={
                        llShowOnly
                          ? "/images/summaryIcon.svg"
                          : "/images/message-dots-solid.svg"
                      }
                      alt="Vector Icon"
                      className="vactorImg"
                    />
                    <p className="Profileheading_change">
                      {llShowOnly ? _t("profileSummary") : _t("aboutMe")}
                    </p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between gap-4 custom-mt-1">
                    <div className="d-flex align-items-center w-100">
                      {llShowOnly ? (
                        <div
                          className="viewSummaryButton d-flex align-items-center justify-content-between"
                          role="button"
                        >
                          {_t("viewSummary")}
                          <img src="/images/arrow-right.svg" />
                        </div>
                      ) : (
                        <p className="Profileheading_change3 aboutMeDescription">
                          {user?.about_me
                            ? user.about_me.length > 10
                              ? `${user.about_me.slice(0, 10)}...`
                              : user.about_me
                            : _t("noInformation")}
                        </p>
                      )}
                    </div>
                    {showReportIcons && !llShowOnly && (
                      <div className="infodorpdown summarydropdum position-relative">
                        <div
                          onClick={() => setShowFreeTextPopup(true)}
                          className="cursor-pointer editButton"
                        >
                          <img
                            src={
                              (user?.about_me?.length ?? 0) === 0
                                ? "/images/addGreen.svg"
                                : "/images/editGreen.svg"
                            }
                          />
                          <p>
                            {(user?.about_me?.length ?? 0) === 0
                              ? `${_t("add")}`
                              : `${_t("edit")}`}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {showReportIcons && llShowOnly && (
            <>
              <div className="col-md-2 send-feedback-button-wrapper">
                <div className="col-auto gap-4 reportButtonWrapper">
                  {WORKSPACE_ROLES_CAPABILITIES?.tenants?.interactionRoles?.includes(
                    originalUser?.current_workspace_role,
                  ) && (
                    <div
                      className="reportbox  d-flex gap-2 cursor-pointer align-items-center"
                      onClick={() => SetIsSentEmailDrawer(true)}
                    >
                      <img
                        src="/images/send-report-green.svg"
                        alt="Vector Icon"
                      />
                      <p>{_t("sendReport")}</p>
                    </div>
                  )}
                  <div className="d-flex gap-2">
                    <div
                      className="reportbox view-details-comp bgColorChange viewDetailIconContainer gap-2 cursor-pointer d-flex align-items-center"
                      onClick={() =>
                        window.open(
                          `${process.env.REACT_APP_SKOR_LITE_URL}${currentLang}/report/${user?._id}`,
                          "_blank",
                        )
                      }
                    >
                      <img
                        src="/images/view-details-green.svg"
                        alt="Vector Icon"
                      />
                    </div>
                    {WORKSPACE_ROLES_CAPABILITIES?.tenants?.generateReport?.includes(
                      originalUser?.current_workspace_role,
                    ) && (
                      <div
                        className="reportbox view-details-comp bgColorChange viewDetailIconContainer gap-2 cursor-pointer d-flex align-items-center"
                        onClick={handleNavigateReport}
                      >
                        <img
                          src="/images/download-report-green.svg"
                          alt="Vector Icon"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <FlatmateModel
        isOpen={showModal}
        onClose={() => {
          setShowModal(false);
        }}
        user={user}
        sharerData={
          llShowOnly ? (fullinfo?.sharersData ?? []) : (user?.sharers ?? [])
        }
        llShowOnly={llShowOnly}
        setSelectedUser={setSelectedUser}
        setFlatmateAddFormModal={setFlatmateAddFormModal}
        updateUserSharerData={updateUserSharerData}
        setShowModal={setShowModal}
      />
      <FlatmateOrGuarantorAddForm
        isOpen={flatmateAddFormModal}
        onClose={() => {
          setFlatmateAddFormModal(false);
          setShowModal(true);
        }}
        selectedUser={selectedUser}
        setModal={setFlatmateAddFormModal}
        updateUserSharerData={updateUserSharerData}
      />
      {showKycPopup && (
        <FullidAuthentication
          user={user}
          isGuarantor={isGuarantor}
          usedFor={"popup"}
          setShowKycPopup={setShowKycPopup}
        />
      )}
      {showFreeTextPopup && (
        <FreeTextModal
          user={user}
          showFreeTextPopup={showFreeTextPopup}
          setShowFreeTextPopup={setShowFreeTextPopup}
          updateTenantData={updateTenantData}
          loadFullInfo={loadFullInfo}
          isPopup={true}
        />
      )}

      {showAmlKycChecks && (
        <KycAmlCheckReportModal
          isOpen={showAmlKycChecks}
          onClose={(e) => setShowAmlKycChecks(false)}
          user={user}
        />
      )}
    </>
  );
};

export default TenantDetailsHeader;
